<template>
  <b-modal
  id="modal-confirm"
  centered
  :hide-footer="true"
  v-model="ModalShowComputed">
    <template slot="modal-header" slot-scope="{ close }">
      <div class="title">
        <p class="" v-html="message"></p>
      </div>
      <button class="btn btn-icon btn-none" @click="close()">
        <svg class="o-icon"><use xlink:href="#close"></use></svg>
      </button>
    </template>
    <div class="container-body text-center">
      <button class="btn btn-secondary btn-secondary-small btn-rounded" @click="closeModal">{{ $t('Cancel') }}</button>
      <button class="ml-3 btn btn-primary btn-primary-small btn-primary-black btn-rounded" @click="confirm">{{ $t('Confirm') }}</button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    ModalShow: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: null
    },
    message: String
  },
  computed: {
    ModalShowComputed: {
      get () {
        return this.ModalShow
      },
      set (newValue) {
        this.$emit('updateModalConfirm', newValue)
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('cancel', false)
    },
    confirm () {
      this.$emit('confirm', this.options)
    }
  }
}
</script>
